import React, { createContext, useState, useEffect, useMemo, useContext } from 'react';
import { initFeatureToggles, isToggleEnabled } from '@paddl/utils-js';
import t from 'prop-types';
import * as Sentry from '@sentry/browser';
const FeatureToggleContext = /*#__PURE__*/createContext({
  isToggleEnabled: () => false,
  isInitialised: false
});
export const useFeatureToggles = () => useContext(FeatureToggleContext);
export const FeatureToggleProvider = _ref => {
  let {
    children
  } = _ref;
  const [isInitialised, setIsInitialised] = useState(false);
  useEffect(() => {
    initFeatureToggles();
    setIsInitialised(true);
    ['organisation', 'experience-records'].forEach(feature => {
      if (isToggleEnabled(feature)) {
        Sentry.setExtra(feature, true);
      }
    });
  }, []);
  const value = useMemo(() => {
    return {
      isInitialised,
      isToggleEnabled
    };
  }, [isInitialised]);
  return /*#__PURE__*/React.createElement(FeatureToggleContext.Provider, {
    value: value
  }, children);
};
FeatureToggleProvider.propTypes = {
  children: t.node.isRequired
};